import * as stylex from "@stylexjs/stylex";
export const type = {
  fontSans: "var(--x7q8bw4)",
  fontMono: "var(--x1wji9ab)",
  clockSize: "var(--x1na80ww)",
  clockWeight: "var(--x161td9w)",
  clockLh: "var(--x1acofya)",
  clockLs: "var(--x1bbgp3q)",
  tempSize: "var(--x1l0b2h)",
  tempWeight: "var(--x1lpqp6i)",
  tempLh: "var(--x1mrumui)",
  tempLs: "var(--x14uzw2z)",
  displayXlSize: "var(--x1qauxo4)",
  displayXlWeight: "var(--xzs7bwz)",
  displayXlLh: "var(--x1dciy94)",
  displayXlLs: "var(--xm08l2h)",
  displayLgSize: "var(--xa253ib)",
  displayLgWeight: "var(--x112jbtd)",
  displayLgLh: "var(--x1dwahtn)",
  displayLgLs: "var(--x1l22z4b)",
  headlineSize: "var(--x6jfbr7)",
  headlineWeight: "var(--xutnru9)",
  headlineLh: "var(--xc8jddb)",
  headlineLs: "var(--x1s0m530)",
  subheadSize: "var(--xl4rbp3)",
  subheadWeight: "var(--x1i13mml)",
  subheadLh: "var(--x94wz7f)",
  subheadLs: "var(--xkgkbnn)",
  cardTitleSize: "var(--xpm8slu)",
  cardTitleWeight: "var(--xvyh4s0)",
  cardTitleLh: "var(--xyzvp3t)",
  cardTitleLs: "var(--x1vkmu1m)",
  bodyLgSize: "var(--x15hovsw)",
  bodyLgWeight: "var(--xzwf3v1)",
  bodyLgLh: "var(--x1xz6yop)",
  bodyLgLs: "var(--xgjmxpa)",
  bodySize: "var(--xq3oedo)",
  bodyWeight: "var(--xw5pzbj)",
  bodyLh: "var(--xrolyim)",
  bodyLs: "var(--x1kwsd5)",
  bodySmSize: "var(--x16m5fmk)",
  bodySmWeight: "var(--xj5t8z8)",
  bodySmLh: "var(--x1rrvbsp)",
  bodySmLs: "var(--x14jwj4n)",
  buttonSize: "var(--xjq1e7k)",
  buttonWeight: "var(--x1h7kb5p)",
  buttonLh: "var(--x12y4qf2)",
  buttonLs: "var(--x103kv8g)",
  eyebrowSize: "var(--x1n32n6s)",
  eyebrowWeight: "var(--xujrdf2)",
  eyebrowLh: "var(--x1135fbf)",
  eyebrowLs: "var(--x18h5kcg)",
  captionSize: "var(--x6opu5z)",
  captionWeight: "var(--x12yzyq2)",
  captionLh: "var(--x6sp16k)",
  captionLs: "var(--x1ypol6n)",
  __varGroupHash__: "x138ayyd"
};